var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "informationOverlay",
      staticClass: "information-overlay",
      class: { active: _vm.status },
    },
    [
      _c(
        "div",
        { staticClass: "description" },
        [
          _vm.status === "enter-join" ? _c("EnterSvg") : _vm._e(),
          _vm._v(" "),
          _vm.status === "enter-create" ? _c("EnterSvg") : _vm._e(),
          _vm._v(" "),
          _vm.status === "inactive"
            ? _c("div", { staticClass: "material-icons" }, [_vm._v("block")])
            : _vm._e(),
          _vm._v(" "),
          _vm.status === "deactive-user"
            ? _c("div", { staticClass: "material-icons" }, [_vm._v("chat")])
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.statusText[_vm.status]))]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.channelStatus
        ? _c(
            "div",
            [
              ["enter-join", "enter-create"].includes(_vm.status)
                ? _c(
                    "SupsisButton",
                    { attrs: { primary: "" }, on: { click: _vm.clickButton } },
                    [
                      _vm._v(
                        "\n            " + _vm._s(_vm.joinText()) + "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      ["deactive-user"].includes(_vm.status) && _vm.isWhatsapp()
        ? _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.sendTemplateMessage } },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.sendTemplateMessage")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      ["enter-create"].includes(_vm.status) &&
      _vm.isWhatsapp() &&
      _vm.whatsappChannels.length > 1
        ? _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.startWhatsappChat } },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.startChatWithDifferentChannel")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              staticClass: "modal-wp-chat-starter",
              attrs: {
                "show-footer": false,
                title: _vm.$t("message.whatsappChatStarter"),
              },
              on: {
                cancel: function () {
                  return (_vm.showWhatsappChatStarterModal = false)
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.contact.whatsappNumber,
                  "channel-override": "",
                  "phone-number-override": "",
                  "default-email": _vm.contact.email,
                  "default-name": _vm.contact.name || _vm.contact.fullname,
                },
                on: {
                  close: function () {
                    return (_vm.showWhatsappChatStarterModal = false)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }